import { createFileRoute } from '@tanstack/react-router';
import { GoalsRoute } from './-goals-route';

/**
 * Everything below `/journeys/goals` that no route of its own claims — any deeper URL the
 * embedded app serves — so the flag gate covers the whole subtree rather than the index
 * alone. The create page and a goal's overview and milestone tab have their own routes.
 */
export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/goals/$')({
  component: GoalsRoute,
});
